import { MediaKind, MediaUploadRequest, MediaUploadResponse } from "@/types/media";

function getApiBase(): string {
  return process.env.NEXT_PUBLIC_API_BASE ?? "/api";
}

export async function requestMediaUploadUrl(payload: MediaUploadRequest): Promise<MediaUploadResponse> {
  const response = await fetch(`${getApiBase()}/media/upload-url`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(`Unable to create upload URL (${response.status})`);
  }

  return response.json() as Promise<MediaUploadResponse>;
}

export async function uploadFileToSignedUrl(uploadUrl: string, file: File, uploadHeaders: Record<string, string>): Promise<void> {
  const response = await fetch(uploadUrl, {
    method: "PUT",
    headers: uploadHeaders,
    body: file,
  });

  if (!response.ok) {
    throw new Error(`File upload failed (${response.status})`);
  }
}

export async function uploadMediaFiles(files: File[], mediaKind: MediaKind): Promise<string[]> {
  const uploadedUrls: string[] = [];

  for (const file of files) {
    const signed = await requestMediaUploadUrl({
      media_kind: mediaKind,
      filename: file.name,
      content_type: file.type || (mediaKind === "image" ? "image/jpeg" : "video/mp4"),
    });

    await uploadFileToSignedUrl(signed.upload_url, file, signed.upload_headers);

    const absolutePermanentUrl = signed.permanent_path.startsWith("/")
      ? `${window.location.origin}${signed.permanent_path}`
      : signed.permanent_url;

    uploadedUrls.push(absolutePermanentUrl);
  }

  return uploadedUrls;
}
